import { render, staticRenderFns } from "./CardTutorial.vue?vue&type=template&id=d72b93f6&scoped=true"
import script from "./CardTutorial.vue?vue&type=script&lang=js"
export * from "./CardTutorial.vue?vue&type=script&lang=js"
import style0 from "./CardTutorial.vue?vue&type=style&index=0&id=d72b93f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72b93f6",
  null
  
)

export default component.exports